module.exports = __webpack_public_path__ + "media/images/Textbox_Icon-afabdf4c.svg";